var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "studentMessageCenter" }, [
    _c(
      "div",
      { staticClass: "studentMessageCenter-left" },
      [
        _c("Title", {
          staticClass: "studentMessageCenter-title",
          attrs: { text: "通知公告" },
        }),
        _vm.noticeDatas.length > 0
          ? _c(
              "ul",
              {
                directives: [
                  {
                    name: "infinite-scroll",
                    rawName: "v-infinite-scroll",
                    value: _vm.load,
                    expression: "load",
                  },
                ],
                staticClass: "notice-lists",
                attrs: {
                  "infinite-scroll-immediate": "",
                  "infinite-scroll-delay": "500",
                  "infinite-scroll-distance": "10",
                },
              },
              _vm._l(_vm.noticeDatas, function (item) {
                return _c(
                  "li",
                  {
                    key: item.id,
                    staticClass: "item",
                    class: _vm.currentData.id == item.id ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.getContent(item)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "con" }, [
                      _vm._v(_vm._s(item.title) + " "),
                    ]),
                    _c("span", { staticClass: "date" }, [
                      _vm._v(_vm._s(item.created_at.substring(0, 10))),
                    ]),
                  ]
                )
              }),
              0
            )
          : _c("ComponentEmpty", { attrs: { title: "暂无数据", tips: "" } }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "studentMessageCenter-right" },
      [
        _c("p", { staticClass: "title" }, [
          _c("span", { staticClass: "tit" }, [
            _vm._v(_vm._s(_vm.currentData.title) + " "),
          ]),
          _c("span", {
            staticClass: "date",
            staticStyle: { "align-self": "flex-end" },
            domProps: { innerHTML: _vm._s(_vm.currentData.created_at) },
          }),
        ]),
        _c("div", {
          staticClass: "content",
          domProps: { innerHTML: _vm._s(_vm.currentData.content) },
        }),
        !_vm.currentData.content
          ? _c("ComponentEmpty", { attrs: { title: "暂无数据", tips: "" } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }